import { useState, HTMLProps, ReactElement } from "react";

import {
  Light as SyntaxHighlighter,
  SyntaxHighlighterProps,
} from "react-syntax-highlighter";
import { stackoverflowLight } from "react-syntax-highlighter/dist/esm/styles/hljs";
import python from "react-syntax-highlighter/dist/esm/languages/hljs/python";
import gcode from "react-syntax-highlighter/dist/esm/languages/hljs/gcode";

import { Icon } from "_/components/icon";

import * as S from "./styled";

// More languages can be added here, but should be kept to the minimum
// required in order to minimize the bundle size.
SyntaxHighlighter.registerLanguage("python", python);
SyntaxHighlighter.registerLanguage("gcode", gcode);

const CustomPre = (props: HTMLProps<HTMLDivElement> & { code: string }) => {
  const { children, style, code, ...rest } = props;
  const [copyState, setCopyState] = useState<
    "notAttempted" | "copied" | "error"
  >("notAttempted");

  // TODO: Refactor this along with the UUID tooltip copy logic to be reusable.
  function copyToClipboard() {
    const copy = async () => {
      try {
        await navigator.clipboard.writeText(code);
        setCopyState("copied");
        setTimeout(() => setCopyState("notAttempted"), 3000);
      } catch {
        setCopyState("error");
        console.error("Could not copy code to clipboard.");
      }
    };

    void copy();
  }

  const iconVariant = (
    {
      notAttempted: "ContentCopy",
      error: "Error",
      copied: "CheckCircle",
    } as const
  )[copyState];

  return (
    <div style={{ ...style, position: "relative", padding: "1em 0" }} {...rest}>
      <S.CopyCode onClick={copyToClipboard}>
        <Icon variant={iconVariant} />
      </S.CopyCode>
      {children}
    </div>
  );
};

export const Code = ({
  className,
  ...props
}: SyntaxHighlighterProps & { className?: string }): ReactElement => {
  const match = /language-(\w+)/.exec(className || "");
  const code = typeof props.children === "string" ? props.children : "";

  return match && typeof props.children === "string" ? (
    <SyntaxHighlighter
      language={match[1]}
      PreTag={(preProps: HTMLProps<HTMLDivElement>) => (
        <CustomPre {...preProps} code={code} />
      )}
      showLineNumbers
      lineNumberStyle={{ color: "#ccc", minWidth: "3.25em" }}
      style={stackoverflowLight}
      {...props}
    />
  ) : (
    <code className={className} {...props} />
  );
};
